/**
 * Generated by orval 🍺
 * Do not edit manually.
 * DeadDrop
 * Agent coordination service with MCP and REST interfaces
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  ConnectionInfoResponse,
  ConnectionResponse,
  CreateConnectionRequest,
  CreateConnectionResponse,
  HTTPValidationError,
  ListConnectionsV1TopicsTopicIdConnectionsGetParams,
  ReplaceConnectionRequest,
  RotateConnectionKeyResponse,
  TestConnectionResponse,
  UpdateConnectionRequest
} from '../model';

import { apiMutator } from '../../../lib/api-mutator';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * Get connection metadata for authenticated connection.
 *
 * Authentication via X-API-Key header. Returns connection name, topic name,
 * and maximum message size for the connection's usage plan.
 *
 * Target response time under 100ms with 3 O(1) database queries.
 *
 * Args:
 *     request: FastAPI request for rate limiting
 *     response: FastAPI response for headers
 *     connection: Authenticated connection from API key
 *
 * Returns:
 *     Connection metadata with name, topic name, and max message size
 *
 * Raises:
 *     AuthenticationError: If API key invalid or connection not active
 *     ConfigurationError: If topic or user not found (database integrity issue)
 * @summary Get Connection Info Endpoint
 */
export const getConnectionInfoEndpointV1ConnectionGet = (

 options?: SecondParameter<typeof apiMutator>,signal?: AbortSignal
) => {


      return apiMutator<ConnectionInfoResponse>(
      {url: `/v1/connection`, method: 'GET', signal
    },
      options);
    }




export const getGetConnectionInfoEndpointV1ConnectionGetQueryKey = () => {
    return [
    `/v1/connection`
    ] as const;
    }


export const getGetConnectionInfoEndpointV1ConnectionGetQueryOptions = <TData = Awaited<ReturnType<typeof getConnectionInfoEndpointV1ConnectionGet>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConnectionInfoEndpointV1ConnectionGet>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetConnectionInfoEndpointV1ConnectionGetQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getConnectionInfoEndpointV1ConnectionGet>>> = ({ signal }) => getConnectionInfoEndpointV1ConnectionGet(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getConnectionInfoEndpointV1ConnectionGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetConnectionInfoEndpointV1ConnectionGetQueryResult = NonNullable<Awaited<ReturnType<typeof getConnectionInfoEndpointV1ConnectionGet>>>
export type GetConnectionInfoEndpointV1ConnectionGetQueryError = unknown


export function useGetConnectionInfoEndpointV1ConnectionGet<TData = Awaited<ReturnType<typeof getConnectionInfoEndpointV1ConnectionGet>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConnectionInfoEndpointV1ConnectionGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getConnectionInfoEndpointV1ConnectionGet>>,
          TError,
          Awaited<ReturnType<typeof getConnectionInfoEndpointV1ConnectionGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetConnectionInfoEndpointV1ConnectionGet<TData = Awaited<ReturnType<typeof getConnectionInfoEndpointV1ConnectionGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConnectionInfoEndpointV1ConnectionGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getConnectionInfoEndpointV1ConnectionGet>>,
          TError,
          Awaited<ReturnType<typeof getConnectionInfoEndpointV1ConnectionGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetConnectionInfoEndpointV1ConnectionGet<TData = Awaited<ReturnType<typeof getConnectionInfoEndpointV1ConnectionGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConnectionInfoEndpointV1ConnectionGet>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Connection Info Endpoint
 */

export function useGetConnectionInfoEndpointV1ConnectionGet<TData = Awaited<ReturnType<typeof getConnectionInfoEndpointV1ConnectionGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConnectionInfoEndpointV1ConnectionGet>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetConnectionInfoEndpointV1ConnectionGetQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * List all connections for topic with optional type filter.
 *
 * Authentication via Bearer token. Verifies topic ownership.
 * Returns non-sensitive config summaries (no API keys or secrets).
 *
 * Args:
 *     topic_id: Topic identifier
 *     request: FastAPI request for rate limiting
 *     response: FastAPI response for headers
 *     current_user: Authenticated user
 *     type: Optional filter by connection type
 *
 * Returns:
 *     List of connections with config summaries
 *
 * Raises:
 *     No exceptions - returns empty list if no connections found
 * @summary List Connections
 */
export const listConnectionsV1TopicsTopicIdConnectionsGet = (
    topicId: string,
    params?: ListConnectionsV1TopicsTopicIdConnectionsGetParams,
 options?: SecondParameter<typeof apiMutator>,signal?: AbortSignal
) => {


      return apiMutator<ConnectionResponse[]>(
      {url: `/v1/topics/${topicId}/connections`, method: 'GET',
        params, signal
    },
      options);
    }




export const getListConnectionsV1TopicsTopicIdConnectionsGetQueryKey = (topicId: string,
    params?: ListConnectionsV1TopicsTopicIdConnectionsGetParams,) => {
    return [
    `/v1/topics/${topicId}/connections`, ...(params ? [params] : [])
    ] as const;
    }


export const getListConnectionsV1TopicsTopicIdConnectionsGetQueryOptions = <TData = Awaited<ReturnType<typeof listConnectionsV1TopicsTopicIdConnectionsGet>>, TError = HTTPValidationError>(topicId: string,
    params?: ListConnectionsV1TopicsTopicIdConnectionsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listConnectionsV1TopicsTopicIdConnectionsGet>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListConnectionsV1TopicsTopicIdConnectionsGetQueryKey(topicId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listConnectionsV1TopicsTopicIdConnectionsGet>>> = ({ signal }) => listConnectionsV1TopicsTopicIdConnectionsGet(topicId,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: topicId !== null && topicId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listConnectionsV1TopicsTopicIdConnectionsGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListConnectionsV1TopicsTopicIdConnectionsGetQueryResult = NonNullable<Awaited<ReturnType<typeof listConnectionsV1TopicsTopicIdConnectionsGet>>>
export type ListConnectionsV1TopicsTopicIdConnectionsGetQueryError = HTTPValidationError


export function useListConnectionsV1TopicsTopicIdConnectionsGet<TData = Awaited<ReturnType<typeof listConnectionsV1TopicsTopicIdConnectionsGet>>, TError = HTTPValidationError>(
 topicId: string,
    params: undefined |  ListConnectionsV1TopicsTopicIdConnectionsGetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listConnectionsV1TopicsTopicIdConnectionsGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listConnectionsV1TopicsTopicIdConnectionsGet>>,
          TError,
          Awaited<ReturnType<typeof listConnectionsV1TopicsTopicIdConnectionsGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListConnectionsV1TopicsTopicIdConnectionsGet<TData = Awaited<ReturnType<typeof listConnectionsV1TopicsTopicIdConnectionsGet>>, TError = HTTPValidationError>(
 topicId: string,
    params?: ListConnectionsV1TopicsTopicIdConnectionsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listConnectionsV1TopicsTopicIdConnectionsGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listConnectionsV1TopicsTopicIdConnectionsGet>>,
          TError,
          Awaited<ReturnType<typeof listConnectionsV1TopicsTopicIdConnectionsGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListConnectionsV1TopicsTopicIdConnectionsGet<TData = Awaited<ReturnType<typeof listConnectionsV1TopicsTopicIdConnectionsGet>>, TError = HTTPValidationError>(
 topicId: string,
    params?: ListConnectionsV1TopicsTopicIdConnectionsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listConnectionsV1TopicsTopicIdConnectionsGet>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Connections
 */

export function useListConnectionsV1TopicsTopicIdConnectionsGet<TData = Awaited<ReturnType<typeof listConnectionsV1TopicsTopicIdConnectionsGet>>, TError = HTTPValidationError>(
 topicId: string,
    params?: ListConnectionsV1TopicsTopicIdConnectionsGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listConnectionsV1TopicsTopicIdConnectionsGet>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListConnectionsV1TopicsTopicIdConnectionsGetQueryOptions(topicId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Create connection for topic with auto-generated credentials.
 *
 * Authentication via Bearer token. Verifies topic ownership and enforces
 * plan limit (max_connections_per_topic). Generates API key for rest/mcp types,
 * HMAC secret for webhook types.
 *
 * Auto-sets status to active for rest/mcp types (pull-only, no testing needed),
 * pending for webhook types (requires testing before activation).
 *
 * Args:
 *     topic_id: Topic identifier
 *     req_obj: Connection creation request
 *     request: FastAPI request for rate limiting
 *     response: FastAPI response for headers
 *     current_user: Authenticated user
 *
 * Returns:
 *     Created connection with credentials (only shown once)
 *
 * Raises:
 *     TopicNotFoundError: If topic not found or not owned by user
 *     TopicAccessDeniedError: If connection limit reached
 *     ConfigValidationError: If connection type not supported or config invalid
 * @summary Create Connection
 */
export const createConnectionV1TopicsTopicIdConnectionsPost = (
    topicId: string,
    createConnectionRequest: CreateConnectionRequest,
 options?: SecondParameter<typeof apiMutator>,signal?: AbortSignal
) => {


      return apiMutator<CreateConnectionResponse>(
      {url: `/v1/topics/${topicId}/connections`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createConnectionRequest, signal
    },
      options);
    }




export const getCreateConnectionV1TopicsTopicIdConnectionsPostMutationKey = () => ['createConnectionV1TopicsTopicIdConnectionsPost'] as const;

export const getCreateConnectionV1TopicsTopicIdConnectionsPostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createConnectionV1TopicsTopicIdConnectionsPost>>, TError,CreateConnectionV1TopicsTopicIdConnectionsPostMutationVariables, TContext>, request?: SecondParameter<typeof apiMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof createConnectionV1TopicsTopicIdConnectionsPost>>, TError,CreateConnectionV1TopicsTopicIdConnectionsPostMutationVariables, TContext> => {

const mutationKey = getCreateConnectionV1TopicsTopicIdConnectionsPostMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createConnectionV1TopicsTopicIdConnectionsPost>>, CreateConnectionV1TopicsTopicIdConnectionsPostMutationVariables> = (props) => {
          const {topicId,data} = props ?? {};

          return  createConnectionV1TopicsTopicIdConnectionsPost(topicId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateConnectionV1TopicsTopicIdConnectionsPostMutationResult = NonNullable<Awaited<ReturnType<typeof createConnectionV1TopicsTopicIdConnectionsPost>>>
    export type CreateConnectionV1TopicsTopicIdConnectionsPostMutationBody = CreateConnectionRequest
    export type CreateConnectionV1TopicsTopicIdConnectionsPostMutationError = HTTPValidationError
    export type CreateConnectionV1TopicsTopicIdConnectionsPostMutationVariables = {topicId: string;data: CreateConnectionRequest}

    /**
 * @summary Create Connection
 */
export const useCreateConnectionV1TopicsTopicIdConnectionsPost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createConnectionV1TopicsTopicIdConnectionsPost>>, TError,CreateConnectionV1TopicsTopicIdConnectionsPostMutationVariables, TContext>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createConnectionV1TopicsTopicIdConnectionsPost>>,
        TError,
        CreateConnectionV1TopicsTopicIdConnectionsPostMutationVariables,
        TContext
      > => {
      return useMutation(getCreateConnectionV1TopicsTopicIdConnectionsPostMutationOptions(options), queryClient);
    }
    /**
 * Delete connection and associated data.
 *
 * Removes connection from database. Database CASCADE automatically deletes
 * associated messages. Only topic owner can delete connections.
 *
 * Authentication via Bearer token.
 *
 * Args:
 *     topic_id: Topic identifier
 *     connection_id: Connection identifier
 *     request: FastAPI request for rate limiting
 *     response: FastAPI response for headers
 *     current_user: Authenticated user
 *
 * Returns:
 *     204 No Content response on successful deletion
 *
 * Raises:
 *     TopicNotFoundError: If topic not found
 *     TopicAccessDeniedError: If user doesn't own topic
 *     ConnectionInvalidError: If connection not found
 * @summary Delete Connection
 */
export const deleteConnectionV1TopicsTopicIdConnectionsConnectionIdDelete = (
    topicId: string,
    connectionId: string,
 options?: SecondParameter<typeof apiMutator>,signal?: AbortSignal
) => {


      return apiMutator<void>(
      {url: `/v1/topics/${topicId}/connections/${connectionId}`, method: 'DELETE', signal
    },
      options);
    }




export const getDeleteConnectionV1TopicsTopicIdConnectionsConnectionIdDeleteMutationKey = () => ['deleteConnectionV1TopicsTopicIdConnectionsConnectionIdDelete'] as const;

export const getDeleteConnectionV1TopicsTopicIdConnectionsConnectionIdDeleteMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteConnectionV1TopicsTopicIdConnectionsConnectionIdDelete>>, TError,DeleteConnectionV1TopicsTopicIdConnectionsConnectionIdDeleteMutationVariables, TContext>, request?: SecondParameter<typeof apiMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteConnectionV1TopicsTopicIdConnectionsConnectionIdDelete>>, TError,DeleteConnectionV1TopicsTopicIdConnectionsConnectionIdDeleteMutationVariables, TContext> => {

const mutationKey = getDeleteConnectionV1TopicsTopicIdConnectionsConnectionIdDeleteMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteConnectionV1TopicsTopicIdConnectionsConnectionIdDelete>>, DeleteConnectionV1TopicsTopicIdConnectionsConnectionIdDeleteMutationVariables> = (props) => {
          const {topicId,connectionId} = props ?? {};

          return  deleteConnectionV1TopicsTopicIdConnectionsConnectionIdDelete(topicId,connectionId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteConnectionV1TopicsTopicIdConnectionsConnectionIdDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof deleteConnectionV1TopicsTopicIdConnectionsConnectionIdDelete>>>

    export type DeleteConnectionV1TopicsTopicIdConnectionsConnectionIdDeleteMutationError = HTTPValidationError
    export type DeleteConnectionV1TopicsTopicIdConnectionsConnectionIdDeleteMutationVariables = {topicId: string;connectionId: string}

    /**
 * @summary Delete Connection
 */
export const useDeleteConnectionV1TopicsTopicIdConnectionsConnectionIdDelete = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteConnectionV1TopicsTopicIdConnectionsConnectionIdDelete>>, TError,DeleteConnectionV1TopicsTopicIdConnectionsConnectionIdDeleteMutationVariables, TContext>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteConnectionV1TopicsTopicIdConnectionsConnectionIdDelete>>,
        TError,
        DeleteConnectionV1TopicsTopicIdConnectionsConnectionIdDeleteMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteConnectionV1TopicsTopicIdConnectionsConnectionIdDeleteMutationOptions(options), queryClient);
    }
    /**
 * Get connection by ID.
 *
 * Authentication via Bearer token. Verifies topic ownership and connection existence.
 * Returns non-sensitive config summary (no API keys or secrets).
 *
 * Args:
 *     topic_id: Topic identifier
 *     connection_id: Connection identifier
 *     request: FastAPI request for rate limiting
 *     response: FastAPI response for headers
 *     current_user: Authenticated user
 *
 * Returns:
 *     Connection details with config summary
 *
 * Raises:
 *     TopicNotFoundError: If topic not found
 *     TopicAccessDeniedError: If user doesn't own topic
 *     ConnectionInvalidError: If connection not found
 * @summary Get Connection By Id
 */
export const getConnectionByIdV1TopicsTopicIdConnectionsConnectionIdGet = (
    topicId: string,
    connectionId: string,
 options?: SecondParameter<typeof apiMutator>,signal?: AbortSignal
) => {


      return apiMutator<ConnectionResponse>(
      {url: `/v1/topics/${topicId}/connections/${connectionId}`, method: 'GET', signal
    },
      options);
    }




export const getGetConnectionByIdV1TopicsTopicIdConnectionsConnectionIdGetQueryKey = (topicId: string,
    connectionId: string,) => {
    return [
    `/v1/topics/${topicId}/connections/${connectionId}`
    ] as const;
    }


export const getGetConnectionByIdV1TopicsTopicIdConnectionsConnectionIdGetQueryOptions = <TData = Awaited<ReturnType<typeof getConnectionByIdV1TopicsTopicIdConnectionsConnectionIdGet>>, TError = HTTPValidationError>(topicId: string,
    connectionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConnectionByIdV1TopicsTopicIdConnectionsConnectionIdGet>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetConnectionByIdV1TopicsTopicIdConnectionsConnectionIdGetQueryKey(topicId,connectionId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getConnectionByIdV1TopicsTopicIdConnectionsConnectionIdGet>>> = ({ signal }) => getConnectionByIdV1TopicsTopicIdConnectionsConnectionIdGet(topicId,connectionId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: topicId !== null && topicId !== undefined && connectionId !== null && connectionId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getConnectionByIdV1TopicsTopicIdConnectionsConnectionIdGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetConnectionByIdV1TopicsTopicIdConnectionsConnectionIdGetQueryResult = NonNullable<Awaited<ReturnType<typeof getConnectionByIdV1TopicsTopicIdConnectionsConnectionIdGet>>>
export type GetConnectionByIdV1TopicsTopicIdConnectionsConnectionIdGetQueryError = HTTPValidationError


export function useGetConnectionByIdV1TopicsTopicIdConnectionsConnectionIdGet<TData = Awaited<ReturnType<typeof getConnectionByIdV1TopicsTopicIdConnectionsConnectionIdGet>>, TError = HTTPValidationError>(
 topicId: string,
    connectionId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConnectionByIdV1TopicsTopicIdConnectionsConnectionIdGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getConnectionByIdV1TopicsTopicIdConnectionsConnectionIdGet>>,
          TError,
          Awaited<ReturnType<typeof getConnectionByIdV1TopicsTopicIdConnectionsConnectionIdGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetConnectionByIdV1TopicsTopicIdConnectionsConnectionIdGet<TData = Awaited<ReturnType<typeof getConnectionByIdV1TopicsTopicIdConnectionsConnectionIdGet>>, TError = HTTPValidationError>(
 topicId: string,
    connectionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConnectionByIdV1TopicsTopicIdConnectionsConnectionIdGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getConnectionByIdV1TopicsTopicIdConnectionsConnectionIdGet>>,
          TError,
          Awaited<ReturnType<typeof getConnectionByIdV1TopicsTopicIdConnectionsConnectionIdGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetConnectionByIdV1TopicsTopicIdConnectionsConnectionIdGet<TData = Awaited<ReturnType<typeof getConnectionByIdV1TopicsTopicIdConnectionsConnectionIdGet>>, TError = HTTPValidationError>(
 topicId: string,
    connectionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConnectionByIdV1TopicsTopicIdConnectionsConnectionIdGet>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Connection By Id
 */

export function useGetConnectionByIdV1TopicsTopicIdConnectionsConnectionIdGet<TData = Awaited<ReturnType<typeof getConnectionByIdV1TopicsTopicIdConnectionsConnectionIdGet>>, TError = HTTPValidationError>(
 topicId: string,
    connectionId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getConnectionByIdV1TopicsTopicIdConnectionsConnectionIdGet>>, TError, TData>>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetConnectionByIdV1TopicsTopicIdConnectionsConnectionIdGetQueryOptions(topicId,connectionId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * Update connection configuration partially.
 *
 * Updates individual fields while preserving unchanged values.
 * Validates topic ownership and name uniqueness.
 *
 * **Config Field Merge Behavior**:
 * - Provided config keys override existing values
 * - Omitted config keys are preserved unchanged
 * - To remove a config key, set its value to `null` explicitly
 * - Empty config object `{}` leaves all config unchanged
 *
 * Examples:
 *     Existing: `{"autoAcknowledge": false, "preferredFormat": "json"}`
 *     PATCH: `{"config": {"autoAcknowledge": true}}`
 *     Result: `{"autoAcknowledge": true, "preferredFormat": "json"}` (merge)
 *
 *     PATCH: `{"config": {"preferredFormat": null}}`
 *     Result: `{"autoAcknowledge": false}` (key deleted)
 *
 * Args:
 *     topic_id: Topic identifier
 *     connection_id: Connection identifier
 *     request_obj: Update request with optional fields
 *     request: FastAPI request for rate limiting
 *     response: FastAPI response for headers
 *     current_user: Authenticated user
 *
 * Returns:
 *     Updated connection details
 *
 * Raises:
 *     TopicNotFoundError: If topic not found
 *     TopicAccessDeniedError: If user doesn't own topic
 *     ConnectionInvalidError: If connection not found
 *     ConfigValidationError: If validation fails
 * @summary Update Connection
 */
export const updateConnectionV1TopicsTopicIdConnectionsConnectionIdPatch = (
    topicId: string,
    connectionId: string,
    updateConnectionRequest: UpdateConnectionRequest,
 options?: SecondParameter<typeof apiMutator>,signal?: AbortSignal
) => {


      return apiMutator<ConnectionResponse>(
      {url: `/v1/topics/${topicId}/connections/${connectionId}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateConnectionRequest, signal
    },
      options);
    }




export const getUpdateConnectionV1TopicsTopicIdConnectionsConnectionIdPatchMutationKey = () => ['updateConnectionV1TopicsTopicIdConnectionsConnectionIdPatch'] as const;

export const getUpdateConnectionV1TopicsTopicIdConnectionsConnectionIdPatchMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateConnectionV1TopicsTopicIdConnectionsConnectionIdPatch>>, TError,UpdateConnectionV1TopicsTopicIdConnectionsConnectionIdPatchMutationVariables, TContext>, request?: SecondParameter<typeof apiMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof updateConnectionV1TopicsTopicIdConnectionsConnectionIdPatch>>, TError,UpdateConnectionV1TopicsTopicIdConnectionsConnectionIdPatchMutationVariables, TContext> => {

const mutationKey = getUpdateConnectionV1TopicsTopicIdConnectionsConnectionIdPatchMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateConnectionV1TopicsTopicIdConnectionsConnectionIdPatch>>, UpdateConnectionV1TopicsTopicIdConnectionsConnectionIdPatchMutationVariables> = (props) => {
          const {topicId,connectionId,data} = props ?? {};

          return  updateConnectionV1TopicsTopicIdConnectionsConnectionIdPatch(topicId,connectionId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateConnectionV1TopicsTopicIdConnectionsConnectionIdPatchMutationResult = NonNullable<Awaited<ReturnType<typeof updateConnectionV1TopicsTopicIdConnectionsConnectionIdPatch>>>
    export type UpdateConnectionV1TopicsTopicIdConnectionsConnectionIdPatchMutationBody = UpdateConnectionRequest
    export type UpdateConnectionV1TopicsTopicIdConnectionsConnectionIdPatchMutationError = HTTPValidationError
    export type UpdateConnectionV1TopicsTopicIdConnectionsConnectionIdPatchMutationVariables = {topicId: string;connectionId: string;data: UpdateConnectionRequest}

    /**
 * @summary Update Connection
 */
export const useUpdateConnectionV1TopicsTopicIdConnectionsConnectionIdPatch = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateConnectionV1TopicsTopicIdConnectionsConnectionIdPatch>>, TError,UpdateConnectionV1TopicsTopicIdConnectionsConnectionIdPatchMutationVariables, TContext>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateConnectionV1TopicsTopicIdConnectionsConnectionIdPatch>>,
        TError,
        UpdateConnectionV1TopicsTopicIdConnectionsConnectionIdPatchMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateConnectionV1TopicsTopicIdConnectionsConnectionIdPatchMutationOptions(options), queryClient);
    }
    /**
 * Replace connection configuration completely.
 *
 * Replaces all connection fields with provided values.
 * Validates topic ownership and name uniqueness.
 *
 * Args:
 *     topic_id: Topic identifier
 *     connection_id: Connection identifier
 *     request_obj: Replacement request with all fields
 *     request: FastAPI request for rate limiting
 *     response: FastAPI response for headers
 *     current_user: Authenticated user
 *
 * Returns:
 *     Replaced connection details
 *
 * Raises:
 *     TopicNotFoundError: If topic not found
 *     TopicAccessDeniedError: If user doesn't own topic
 *     ConnectionInvalidError: If connection not found
 *     ConfigValidationError: If validation fails
 * @summary Replace Connection
 */
export const replaceConnectionV1TopicsTopicIdConnectionsConnectionIdPut = (
    topicId: string,
    connectionId: string,
    replaceConnectionRequest: ReplaceConnectionRequest,
 options?: SecondParameter<typeof apiMutator>,signal?: AbortSignal
) => {


      return apiMutator<ConnectionResponse>(
      {url: `/v1/topics/${topicId}/connections/${connectionId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: replaceConnectionRequest, signal
    },
      options);
    }




export const getReplaceConnectionV1TopicsTopicIdConnectionsConnectionIdPutMutationKey = () => ['replaceConnectionV1TopicsTopicIdConnectionsConnectionIdPut'] as const;

export const getReplaceConnectionV1TopicsTopicIdConnectionsConnectionIdPutMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof replaceConnectionV1TopicsTopicIdConnectionsConnectionIdPut>>, TError,ReplaceConnectionV1TopicsTopicIdConnectionsConnectionIdPutMutationVariables, TContext>, request?: SecondParameter<typeof apiMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof replaceConnectionV1TopicsTopicIdConnectionsConnectionIdPut>>, TError,ReplaceConnectionV1TopicsTopicIdConnectionsConnectionIdPutMutationVariables, TContext> => {

const mutationKey = getReplaceConnectionV1TopicsTopicIdConnectionsConnectionIdPutMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof replaceConnectionV1TopicsTopicIdConnectionsConnectionIdPut>>, ReplaceConnectionV1TopicsTopicIdConnectionsConnectionIdPutMutationVariables> = (props) => {
          const {topicId,connectionId,data} = props ?? {};

          return  replaceConnectionV1TopicsTopicIdConnectionsConnectionIdPut(topicId,connectionId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReplaceConnectionV1TopicsTopicIdConnectionsConnectionIdPutMutationResult = NonNullable<Awaited<ReturnType<typeof replaceConnectionV1TopicsTopicIdConnectionsConnectionIdPut>>>
    export type ReplaceConnectionV1TopicsTopicIdConnectionsConnectionIdPutMutationBody = ReplaceConnectionRequest
    export type ReplaceConnectionV1TopicsTopicIdConnectionsConnectionIdPutMutationError = HTTPValidationError
    export type ReplaceConnectionV1TopicsTopicIdConnectionsConnectionIdPutMutationVariables = {topicId: string;connectionId: string;data: ReplaceConnectionRequest}

    /**
 * @summary Replace Connection
 */
export const useReplaceConnectionV1TopicsTopicIdConnectionsConnectionIdPut = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof replaceConnectionV1TopicsTopicIdConnectionsConnectionIdPut>>, TError,ReplaceConnectionV1TopicsTopicIdConnectionsConnectionIdPutMutationVariables, TContext>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof replaceConnectionV1TopicsTopicIdConnectionsConnectionIdPut>>,
        TError,
        ReplaceConnectionV1TopicsTopicIdConnectionsConnectionIdPutMutationVariables,
        TContext
      > => {
      return useMutation(getReplaceConnectionV1TopicsTopicIdConnectionsConnectionIdPutMutationOptions(options), queryClient);
    }
    /**
 * Rotate connection authentication credentials.
 *
 * Generates new credentials and immediately invalidates old credentials.
 * Credential type depends on connection type (API key vs HMAC secret).
 *
 * Args:
 *     topic_id: Topic identifier
 *     connection_id: Connection identifier
 *     request: FastAPI request for rate limiting
 *     response: FastAPI response for headers
 *     current_user: Authenticated user
 *
 * Returns:
 *     New credentials (only shown once)
 *
 * Raises:
 *     TopicNotFoundError: If topic not found
 *     TopicAccessDeniedError: If user doesn't own topic
 *     ConnectionInvalidError: If connection not found
 *     ConfigValidationError: If connection type has no registered adapter
 * @summary Rotate Connection Key
 */
export const rotateConnectionKeyV1TopicsTopicIdConnectionsConnectionIdRotateKeyPost = (
    topicId: string,
    connectionId: string,
 options?: SecondParameter<typeof apiMutator>,signal?: AbortSignal
) => {


      return apiMutator<RotateConnectionKeyResponse>(
      {url: `/v1/topics/${topicId}/connections/${connectionId}/rotate-key`, method: 'POST', signal
    },
      options);
    }




export const getRotateConnectionKeyV1TopicsTopicIdConnectionsConnectionIdRotateKeyPostMutationKey = () => ['rotateConnectionKeyV1TopicsTopicIdConnectionsConnectionIdRotateKeyPost'] as const;

export const getRotateConnectionKeyV1TopicsTopicIdConnectionsConnectionIdRotateKeyPostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rotateConnectionKeyV1TopicsTopicIdConnectionsConnectionIdRotateKeyPost>>, TError,RotateConnectionKeyV1TopicsTopicIdConnectionsConnectionIdRotateKeyPostMutationVariables, TContext>, request?: SecondParameter<typeof apiMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof rotateConnectionKeyV1TopicsTopicIdConnectionsConnectionIdRotateKeyPost>>, TError,RotateConnectionKeyV1TopicsTopicIdConnectionsConnectionIdRotateKeyPostMutationVariables, TContext> => {

const mutationKey = getRotateConnectionKeyV1TopicsTopicIdConnectionsConnectionIdRotateKeyPostMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof rotateConnectionKeyV1TopicsTopicIdConnectionsConnectionIdRotateKeyPost>>, RotateConnectionKeyV1TopicsTopicIdConnectionsConnectionIdRotateKeyPostMutationVariables> = (props) => {
          const {topicId,connectionId} = props ?? {};

          return  rotateConnectionKeyV1TopicsTopicIdConnectionsConnectionIdRotateKeyPost(topicId,connectionId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RotateConnectionKeyV1TopicsTopicIdConnectionsConnectionIdRotateKeyPostMutationResult = NonNullable<Awaited<ReturnType<typeof rotateConnectionKeyV1TopicsTopicIdConnectionsConnectionIdRotateKeyPost>>>

    export type RotateConnectionKeyV1TopicsTopicIdConnectionsConnectionIdRotateKeyPostMutationError = HTTPValidationError
    export type RotateConnectionKeyV1TopicsTopicIdConnectionsConnectionIdRotateKeyPostMutationVariables = {topicId: string;connectionId: string}

    /**
 * @summary Rotate Connection Key
 */
export const useRotateConnectionKeyV1TopicsTopicIdConnectionsConnectionIdRotateKeyPost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rotateConnectionKeyV1TopicsTopicIdConnectionsConnectionIdRotateKeyPost>>, TError,RotateConnectionKeyV1TopicsTopicIdConnectionsConnectionIdRotateKeyPostMutationVariables, TContext>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof rotateConnectionKeyV1TopicsTopicIdConnectionsConnectionIdRotateKeyPost>>,
        TError,
        RotateConnectionKeyV1TopicsTopicIdConnectionsConnectionIdRotateKeyPostMutationVariables,
        TContext
      > => {
      return useMutation(getRotateConnectionKeyV1TopicsTopicIdConnectionsConnectionIdRotateKeyPostMutationOptions(options), queryClient);
    }
    /**
 * Test connection endpoint.
 *
 * Behavior varies by connection type:
 * - Webhook: Sends test payload with HMAC signature to validate endpoint.
 *   Updates status to 'active' on successful test (2xx response).
 * - REST/MCP: Returns success immediately (pull-only, no endpoint to test).
 *
 * Authentication via Bearer token.
 *
 * Args:
 *     topic_id: Topic identifier
 *     connection_id: Connection identifier
 *     request: FastAPI request for rate limiting
 *     response: FastAPI response for headers
 *     current_user: Authenticated user
 *
 * Returns:
 *     Test result with status code, error details, and response time
 *
 * Raises:
 *     TopicNotFoundError: If topic not found
 *     TopicAccessDeniedError: If user doesn't own topic
 *     ConnectionInvalidError: If connection not found
 *     ConfigValidationError: If connection type has no registered adapter
 * @summary Test Connection
 */
export const testConnectionV1TopicsTopicIdConnectionsConnectionIdTestPost = (
    topicId: string,
    connectionId: string,
 options?: SecondParameter<typeof apiMutator>,signal?: AbortSignal
) => {


      return apiMutator<TestConnectionResponse>(
      {url: `/v1/topics/${topicId}/connections/${connectionId}/test`, method: 'POST', signal
    },
      options);
    }




export const getTestConnectionV1TopicsTopicIdConnectionsConnectionIdTestPostMutationKey = () => ['testConnectionV1TopicsTopicIdConnectionsConnectionIdTestPost'] as const;

export const getTestConnectionV1TopicsTopicIdConnectionsConnectionIdTestPostMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof testConnectionV1TopicsTopicIdConnectionsConnectionIdTestPost>>, TError,TestConnectionV1TopicsTopicIdConnectionsConnectionIdTestPostMutationVariables, TContext>, request?: SecondParameter<typeof apiMutator>}
): UseMutationOptions<Awaited<ReturnType<typeof testConnectionV1TopicsTopicIdConnectionsConnectionIdTestPost>>, TError,TestConnectionV1TopicsTopicIdConnectionsConnectionIdTestPostMutationVariables, TContext> => {

const mutationKey = getTestConnectionV1TopicsTopicIdConnectionsConnectionIdTestPostMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof testConnectionV1TopicsTopicIdConnectionsConnectionIdTestPost>>, TestConnectionV1TopicsTopicIdConnectionsConnectionIdTestPostMutationVariables> = (props) => {
          const {topicId,connectionId} = props ?? {};

          return  testConnectionV1TopicsTopicIdConnectionsConnectionIdTestPost(topicId,connectionId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type TestConnectionV1TopicsTopicIdConnectionsConnectionIdTestPostMutationResult = NonNullable<Awaited<ReturnType<typeof testConnectionV1TopicsTopicIdConnectionsConnectionIdTestPost>>>

    export type TestConnectionV1TopicsTopicIdConnectionsConnectionIdTestPostMutationError = HTTPValidationError
    export type TestConnectionV1TopicsTopicIdConnectionsConnectionIdTestPostMutationVariables = {topicId: string;connectionId: string}

    /**
 * @summary Test Connection
 */
export const useTestConnectionV1TopicsTopicIdConnectionsConnectionIdTestPost = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof testConnectionV1TopicsTopicIdConnectionsConnectionIdTestPost>>, TError,TestConnectionV1TopicsTopicIdConnectionsConnectionIdTestPostMutationVariables, TContext>, request?: SecondParameter<typeof apiMutator>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof testConnectionV1TopicsTopicIdConnectionsConnectionIdTestPost>>,
        TError,
        TestConnectionV1TopicsTopicIdConnectionsConnectionIdTestPostMutationVariables,
        TContext
      > => {
      return useMutation(getTestConnectionV1TopicsTopicIdConnectionsConnectionIdTestPostMutationOptions(options), queryClient);
    }
